import React from 'react';
import type { FC } from 'react';
import { Alert, Badge, Box, Spinner, Text, useAsync } from '@wix/cli-ui-kit';
import { match } from 'variant';
import { writeJson } from '@wix/cli-fs';
import {
  getWixConfigFilePath,
  WIX_CONFIG_FILENAME,
} from '@wix/cli-core-definitions';
import type { WixAstroConfig } from '@wix/cli-astro-definitions';
import type { ProjectData } from '../hooks/create-project.js';

export const WriteConfig: FC<{
  businessId: string;
  projectData: ProjectData;
  targetParentFolder: string;
  onDone: () => void;
}> = ({ businessId, projectData, targetParentFolder, onDone }) => {
  const { status } = useAsync(async () => {
    await writeJson(
      getWixConfigFilePath(targetParentFolder),
      {
        projectType: 'Site',
        appId: projectData.projectId,
        siteId: businessId,
        site: {
          outputDirectory: './dist',
        },
      } satisfies WixAstroConfig,
      { spaces: 2 }
    );

    onDone();
  }, []);

  return (
    <>
      {match(status, {
        Error: () => null,
        Loading: () => (
          <Box marginBottom={1}>
            <Spinner text="Saving settings..." />
          </Box>
        ),
        Success: () => (
          <Box marginLeft={-2} marginBottom={1}>
            <Alert type="success">
              <Badge skin="success">Success</Badge>{' '}
              <Text>Settings saved to `{WIX_CONFIG_FILENAME}`.</Text>
            </Alert>
          </Box>
        ),
        NotRequested: () => null,
      })}
    </>
  );
};
